<div class="lv-custom-tree">
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" >
  <mat-tree-node *matTreeNodeDef="let node">
    <button mat-icon-button disabled></button>
    <mat-checkbox [disabled]="downloadVerpflichtend" [checked]="checkboxSelected(node)"
                  (change)="nodeSelectionToggle(node)">
      {{node.item}}
    </mat-checkbox>
  </mat-tree-node>
  <mat-tree-node  *matTreeNodeDef="let node; when: hasChildren">
    <mat-checkbox [disabled]="downloadVerpflichtend" [checked]="checkboxSelected(node)"
                  [indeterminate]="descendantsPartiallySelected(node)"
                  (change)="selectAmAll()">
      {{node.item}}
    </mat-checkbox>
  </mat-tree-node>
</mat-tree>
</div>
<mat-slide-toggle *ngIf="!downloadVerpflichtend" class="lv-toggle-button" (click)="selectDoksVorvertraglicheInformationen()" [(ngModel)]="vorvertraglicheInformationenGewaehlt">
  {{'DOKUMENT_TREE_ELEMENT.TOGGLE_BUTTON.DOKUMENTE_VORVERTRAGLICHE_INFORMATIONEN' | translate}}
</mat-slide-toggle>
